exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.recover-container[data-v-31ab78e9]{width:500px;margin:24px auto;display:block;padding:48px 0\n}\n.recover-container .title-login-entrar[data-v-31ab78e9]{font-size:1.875rem;font-weight:bold;letter-spacing:.38px;color:#000;text-align:center;text-transform:uppercase;padding-top:2.5rem;padding-bottom:1.2rem\n}\n.recover-container .recuperar-text[data-v-31ab78e9]{font-size:1.125rem;text-align:center;padding-top:1.5rem;padding-bottom:1.75rem\n}\n.recover-container button[data-v-31ab78e9]{display:block;width:100%;margin:12px 0;cursor:pointer\n}\n.recover-container button[data-v-31ab78e9]{margin:42px auto;border:none;text-align:center;padding:18px;display:block;background-color:#fecc39;color:#fff;outline:none;width:280px;font-size:1.25rem\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31ab78e9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/correct_password/CorrectPassword.vue
// module id = 15kr
// module chunks = 1